<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>活动列表</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 搜索和添加 -->
    <el-form :inline="true" style="margin-top: 20px;">
      <el-form-item>
        <el-input size="small" v-model="title1" placeholder="请输入活动标题"></el-input>
      </el-form-item>
      <el-form-item label="审核状态：">
        <el-select size="small" v-model="status1" placeholder="请选择审核状态">
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="chongzhi">重置</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="openAct()">添加</el-button>
      </el-form-item>
    </el-form>

    <!--列表-->
    <el-table size="small" :data="actData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中"
      style="width: 100%;" v-horizontal-scroll>
      <el-table-column align="center" prop="title" label="活动标题" width="120"></el-table-column>
      <el-table-column align="center" prop="image" label="封面图" width="120">
        <template slot-scope="scope">
          <el-image v-if="scope.row.image" style="width: 90px;height: 90px;" :src="scope.row.image"
            :preview-src-list="[scope.row.image]" />
          <div v-if="scope.row.image == null">没有图片</div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="time" label="时间" width="160"></el-table-column>
      <el-table-column align="center" prop="circlesId" label="圈层" width="160">
        <template slot-scope="scope">
          <div>{{ typeName(scope.row.circlesId) }}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="register" label="报名人数" width="100"></el-table-column>
      <el-table-column align="center" prop="area" label="地区" width="100"></el-table-column>
      <el-table-column align="center" prop="tel" label="联系方式" width="120"></el-table-column>
      <el-table-column align="center" prop="status" label="报名时效" :formatter="Status" width="100"></el-table-column>
      <el-table-column align="center" prop="createTime" label="创建时间" width="160">
        <template slot-scope="scope">
          <div>{{ transformDate(scope.row.createTime) }}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" width="400" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="getUsers(scope.row)">查看报名列表</el-button>
          <el-button size="mini" type="primary" @click="getDetails(scope.row)">查看活动详情</el-button>
          <el-button size="mini" type="primary" @click="openAct(scope.row)">修改</el-button>
          <el-button size="mini" type="danger" @click="deleAct(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 编辑界面 -->
    <el-dialog :title="tit" :visible.sync="editFormVisiible" width="80%">
      <el-form label-width="120px">
        <el-form-item label="活动标题" prop="title">
          <el-input size="small" v-model="title" auto-complete="off" placeholder="请输入活动标题"></el-input>
        </el-form-item>
        <el-form-item label="活动内容" style="height: 600px;">
          <quill-editor v-model="content" :options="editorOption" style="height: 460px;" ref="QuillEditor">
          </quill-editor>
        </el-form-item>
        <el-form-item label="封面图">
          <div style="display: flex; align-items: center;">
            <el-upload action="" :http-request="mainImgUpload" :show-file-list="false" list-type="picture-card">
              <i class="el-icon-plus"></i>
            </el-upload>
            <img v-if="image != ''" :src="image" style="width: 140px;height: 140px;margin-left: 14px;">
          </div>
        </el-form-item>
        <el-form-item label="对应圈层" prop="tel">
          <el-select v-model="circlesId" placeholder="请选择">
            <el-option v-for="(item, index) in circleLst" :key="index" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="时间" prop="time">
          <el-date-picker type="datetime" align="center" v-model="time" placeholder="请选择时间"
            value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
        </el-form-item>
        <el-form-item label="报名人数" prop="register">
          <el-input size="small" v-model="register" auto-complete="off" placeholder="请输入报名人数"></el-input>
        </el-form-item>
        <el-form-item label="地区" prop="area">
          <el-input size="small" v-model="area" auto-complete="off" placeholder="请输入地区"></el-input>
        </el-form-item>

        <el-form-item label="联系方式" prop="tel">
          <el-input size="small" v-model="tel" auto-complete="off" placeholder="请输入联系方式"></el-input>
        </el-form-item>
        <el-form-item label="活动时效">
          <el-select v-model="value" placeholder="请选择活动时效">
            <el-option v-for="item in options1" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog()'>取消</el-button>
        <el-button size="small" type="primary" :loading="loading" @click="addAct()" v-if="tit == '添加'">添加</el-button>
        <el-button size="small" type="primary" :loading="loading" @click="upAct()" v-if="tit == '修改'">修改</el-button>
      </div>
    </el-dialog>

    <!-- 富文本图片编辑 -->
    <el-dialog title="选择图片" :visible.sync="uploadVisible" width="30%">
      <div>
        <div class="upload-demo">
          <el-upload action="" :http-request="mainImgUpload1" :show-file-list="false" list-type="picture-card">
            <i class="el-icon-plus"></i>
          </el-upload>
        </div>
      </div>

    </el-dialog>

    <!-- 活动详情 -->
    <el-dialog title="活动详情页：" :visible.sync="editFormDetails" class="Actxq">
      <el-form label-width="120px">
        <el-form-item label="活动标题：" prop="title">
          <span v-html="this.Details.title"></span>
        </el-form-item>
        <el-form-item label="活动内容：">
          <span v-html="this.Details.content" style="display: block; width: 100%"></span>
        </el-form-item>
        <el-form-item label="封面图：">
          <el-image v-if="this.Details.image" style="width: 140px;height: 140px;margin-left: 14px;"
            :src="this.Details.image" :preview-src-list="[this.Details.image]" />
        </el-form-item>
        <el-form-item label="时间：" prop="time">
          <span v-html="this.Details.time"></span>
        </el-form-item>
        <el-form-item label="报名人数：" prop="register">
          <span v-html="this.Details.register"></span>
        </el-form-item>
        <el-form-item label="地区：" prop="area">
          <span v-html="this.Details.area"></span>
        </el-form-item>
        <el-form-item label="联系方式：" prop="tel">
          <span v-html="this.Details.tel"></span>
        </el-form-item>
        <el-form-item label="创建时间：" prop="createTime">
          {{ transformDate(this.Details.createTime) }}
        </el-form-item>
        <el-form-item label="活动时效：">
          <span v-if="this.Details.status == 0" :value="this.Details.status">未生效</span>
          <span v-if="this.Details.status == 1" :value="this.Details.status">报名中</span>
          <span v-if="this.Details.status == 2" :value="this.Details.status">报名结束</span>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 用户报名列表 -->
    <el-dialog title="报名用户列表" :visible.sync="editFormUsers">
      <el-table size="small" :data="baoMing" highlight-current-row v-loading="loading" border
        element-loading-text="拼命加载中" style="width: 100%;">
        <el-table-column align="center" prop="avatar" label="用户头像">
          <template slot-scope="scope">
            <el-image v-if="scope.row.avatar" style="width: 90px;height: 90px;" :src="scope.row.avatar"
              :preview-src-list="[scope.row.avatar]" />
            <div v-if="scope.row.avatar == null">没有图片</div>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="nickName" label="用户昵称"></el-table-column>
        <el-table-column align="center" prop="sex" label="性别" :formatter="sexf" width="100"></el-table-column>
        <el-table-column align="center" prop="mobile" label="联系方式"></el-table-column>
        <el-table-column align="center" prop="createTime" label="创建时间">
          <template slot-scope="scope">
            <div>{{ transformDate(scope.row.createTime) }}</div>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

  </div>
</template>

<script>
import client from "@/utils/ossClient.js";
import Pagination from '../../components/Pagination'
import VueQuillEditor from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import { getActivityList } from '../../api/userMG'
import { deleteActivity } from '../../api/userMG'
import { addActivity } from '../../api/userMG'
import { upActivity } from '../../api/userMG'
import { getActivityInfo } from '../../api/userMG'
import { getActivityUserInfo } from '../../api/userMG'
import { getCirclesList } from '../../api/userMG'
// 工具栏配置
const toolbarOptions = [
  ["bold", "italic", "underline", "strike"], // toggled buttons
  ["blockquote", "code-block"],

  [{ header: 1 }, { header: 2 }], // custom button values
  [{ list: "ordered" }, { list: "bullet" }],
  [{ script: "sub" }, { script: "super" }], // superscript/subscript
  [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
  [{ direction: "rtl" }], // text direction

  [{ size: ["small", false, "large", "huge"] }], // custom dropdown
  [{ header: [1, 2, 3, 4, 5, 6, false] }],

  [{ color: [] }, { background: [] }], // dropdown with defaults from theme
  [{ font: [] }],
  [{ align: [] }],
  ["link", "image", "video"], // 对于图片上传这是重点
  ["clean"], // remove formatting button
];
export default {
  data() {
    return {
      actData: [],
      loading: false,
      editFormVisiible: false,
      tit: '添加',
      options: [
        {
          value: -1,
          label: '全部'
        }, {
          value: 0,
          label: '未生效'
        }, {
          value: 1,
          label: '报名中'
        }, {
          value: 2,
          label: '报名结束'
        }],
      options1: [{
        value: 0,
        label: '未生效'
      }, {
        value: 1,
        label: '报名中'
      }, {
        value: 2,
        label: '报名结束'
      }],
      value: '',
      id: '',
      title: '',
      content: '',
      image: '',
      time: '',
      register: '',
      area: '',
      tel: '',
      status: '',
      sort: '',
      createTime: '',
      circlesId: '',//圈层id
      editFormDetails: false,
      editorOption: {
        modules: {
          toolbar: {
            container: toolbarOptions, // 工具栏
            handlers: {
              image: (value) => {
                if (value) {
                  // 在这里编写图片按钮点击操作
                  this.uploadVisible = true;
                  this.cursorIndex =
                    this.$refs.QuillEditor.quill.getSelection().index;
                } else {
                  this.quill.format("image", false);
                }
              },
            },
          },
        },
      },
      uploadVisible: false,
      Details: [],
      editFormUsers: false,
      baoMing: [],
      circleLst: [],
      title1: '',
      status1: -1,
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 20,
        total: 10
      },
    }
  },
  created() {
    this.getAct(1)
    this.getCirclesListFn()
  },
  // 注册组件
  components: {
    Pagination
  },
  computed: {
    typeName() {
      return circlesId => {
        let str = ''
        this.circleLst.forEach(item => {
          if (item.id == circlesId) {
            return str = item.name
          }
        });
        return str
      }
    }
  },
  methods: {
    getCirclesListFn() {
      getCirclesList().then(res => {
        if (res.code == 200) {
          this.circleLst = res.data.list
        }
      })
    },
    // 判断性别
    sexf: function (row) {
      if (row.sex == 1) {
        return "男"
      } else {
        return "女"
      }
    },
    // 查询活动报名用户列表
    getUsers(row) {
      this.loading = true;
      this.editFormUsers = true;
      let data = {
        id: row.id,
        page: 0
      }
      getActivityUserInfo(data).then((res) => {
        this.loading = false;
        if (res.code != 200) {
          this.$Message({
            type: "info",
            message: res.msg
          });
        } else {
          this.baoMing = res.data.data;
          return;
        }
      })
    },
    // 查看活动详情
    getDetails(row) {
      this.loading = true;
      this.editFormDetails = true;
      let data = {
        id: row.id
      }
      getActivityInfo(data).then((res) => {
        this.loading = false;
        if (res.code != 200) {
          this.$Message({
            type: "info",
            message: res.msg
          });
        } else {
          this.Details = res.data.data;
          return;
        }
      })
    },
    // 富文本图片上传
    mainImgUpload1(file) {
      let self = this
      // 判断扩展名
      const tmpcnt = file.file.name.lastIndexOf(".");
      const exname = file.file.name.substring(tmpcnt + 1);
      const names = ["jpg", "jpeg", "webp", "png", "bmp"];
      if (names.indexOf(exname) < 0) {
        this.$message.error("不支持的格式!");
        return;
      }
      const fileName = file.file.uid + "." + exname;
      client
        .put(fileName, file.file)
        .then((res) => {
          if (res.url) {
            self.getUrl(res.url)
            // this.content = res.url
          } else {
            this.$message.error("文件上传失败");
          }
        })
        .catch((err) => { });
    },
    getUrl(url) {
      console.log('getUrl=====================url', url)
      this.uploadVisible = false;
      // 获取富文本组件实例
      let quill = this.$refs.QuillEditor.quill;
      // 如果上传成功
      if (url) {
        // 插入图片，res为服务器返回的图片链接地址
        quill.insertEmbed(this.cursorIndex, "image", url);
        // 调整光标到最后
        quill.setSelection(this.cursorIndex + 1);
      } else {
        // 提示上传失败信息
      }
    },
    // 修改
    upAct() {
      this.loading = true,
        upActivity({
          id: this.id,
          title: this.title,
          content: this.content,
          image: this.image,
          time: this.time,
          register: this.register,
          area: this.area,
          tel: this.tel,
          status: this.value,
          sort: this.sort,
          createTime: this.createTime,
          circlesId: this.circlesId,
        }).then((res) => {
          this.loading = false;
          if (res.code == 200) {
            this.editFormVisiible = false
            this.$message.success(res.msg)
            this.getAct(1)
          } else {
            this.editFormVisiible = false
            this.$message.error(res.msg);
          }
        })
    },
    // 自定义上传方法
    mainImgUpload(file) {
      // 判断扩展名
      const tmpcnt = file.file.name.lastIndexOf(".");
      const exname = file.file.name.substring(tmpcnt + 1);
      const names = ["jpg", "jpeg", "webp", "png", "bmp"];
      if (names.indexOf(exname) < 0) {
        this.$message.error("不支持的格式!");
        return;
      }
      const fileName = file.file.uid + "." + exname;
      client
        .put(fileName, file.file)
        .then((res) => {
          if (res.url) {
            this.image = res.url
            // this.image.push(res.url)
          } else {
            this.$message.error("文件上传失败");
          }
        })
        .catch((err) => { });
    },
    // 添加
    addAct() {
      this.loading = true
      addActivity({
        title: this.title,
        content: this.content,
        image: this.image,
        time: this.time,
        register: this.register,
        area: this.area,
        tel: this.tel,
        status: this.value,
        createTime: this.createTime,
        sort: '',
        circlesId: this.circlesId,
      }).then((res) => {
        if (res.code == 200) {
          this.getAct(1)
          this.loading = false
          this.$message.success(res.msg)
          this.editFormVisiible = false
        } else {
          this.editFormVisiible = false
          this.$message.error(res.msg)
          this.loading = false
        }
      })
    },
    // 关闭编辑对话框
    closeDialog() {
      this.editFormVisiible = false
      this.$message({
        type: 'info',
        message: '已取消编辑'
      })
    },
    // 打开编辑页面
    openAct(row) {
      this.editFormVisiible = true;
      if (row != undefined && row != "undefined") {

        this.tit = "修改";
        this.id = row.id,
          this.title = row.title;
        this.content = row.content;
        this.image = row.image;
        // this.image = JSON.parse(row.image);
        this.time = row.time;
        this.register = row.register;
        this.area = row.area;
        this.tel = row.tel;
        this.value = row.status;
        this.sort = row.sort;
        this.createTime = row.createTime;
        this.circlesId = row.circlesId

      } else {
        this.tit = "添加";
        this.title = "";
        this.content = "";
        this.image = "";
        this.time = "";
        this.register = "";
        this.area = " ";
        this.tel = " ";
        this.circlesId = '';
        this.value = " ";
      }
    },
    // status值转换
    Status: function (row) {
      if (row.status == 0) {
        return "未生效"
      } else if (row.status == 1) {
        return "报名中"
      } else if (row.status == 2) {
        return "报名结束"
      }
    },
    // 删除活动
    deleAct(row) {
      this.$confirm('确定删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        let data = {
          id: row.id
        }
        deleteActivity(data).then(res => {
          if (res.code == 200) {
            this.$message.success(res.msg)
            this.getAct(1)
          } else {
            this.$message.error(res.msg);
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    // 分页插件事件
    callFather(parm) {
      this.pageparm.page = parm.currentPage
      this.getdata(parm.currentPage)
    },
    // 搜索事件
    search() {
      this.getAct(1)
    },
    // 重置数据
    chongzhi() {
      this.status1 = -1
      this.title1 = ''
      this.getAct(1)
    },
    // 获取活动列表
    getAct(page) {
      this.loading = true
      let data = {
        title: this.title1,
        status: this.status1,
        page: (page - 1) * 20
      }
      getActivityList(data).then((res) => {
        this.loading = false
        if (res.code != 200) {
          this.$Message({
            type: "info",
            message: res.msg,
          });
        } else {
          this.actData = res.data.list;
          this.pageparm.currentPage = page;
          this.pageparm.total = res.data.count;
          return;
        }
      })
    }
  }

}
</script>

<style>
.Actxq span p {
  margin-top: -1px;
  width: 100%;
}

.Actxq span p img {
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/views/activity/Activity.vue